import { combineReducers } from 'redux';
// Import reducers
import table from './packets_availability_table_reducer';
import form from './packets_availability_form_reducer';

export default combineReducers({
	table,
	form
});
